export const AUTH_CAROUSEL_IMAGES = [
  '/backgrounds/auth/cover.jpeg',
  '/backgrounds/auth/2.jpeg',
];
